var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner text-center flex justify-center items-center text-cyan-300",class:`${_vm.textSizes[_vm.size]}`},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-animation-target flex justify-center items-center"},[_c('i',{staticClass:"sr-2 sr-v2-spinner"})])
}]

export { render, staticRenderFns }